import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrollt bei jedem Routenwechsel automatisch nach oben.
 * Wird einmalig direkt unter <BrowserRouter> gerendert.
 *
 * Verhalten:
 * - Ignoriert Hash-Links innerhalb derselben Seite (#section)
 * - Verwendet `auto` (kein Smooth-Scroll), damit der Sprung sofort passiert
 *   und der Nutzer nicht erst eine Animation sehen muss.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // jump-to-anchor cases: lass den Browser machen
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
